import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';
import i18n from '@/locales/i18n';
import { resetLocalizedReferenceData } from '@/locales/localizedReferenceData';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 30,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  useEffect(() => {
    const resetLocalizedQueries = () => {
      void resetLocalizedReferenceData(queryClient);
    };

    i18n.on('languageChanged', resetLocalizedQueries);

    return () => {
      i18n.off('languageChanged', resetLocalizedQueries);
    };
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
